import React from "react";

const WholePageSearchResults = ({ results }) => {
  let currentCategory = "";
  let list = [];

  results.forEach(function(element) {
    let category = element.category;
    if (currentCategory !== element.category) {
      if (element.count > 1) {
        if (element.category === "Location") category = "locations";
        else if (element.category === "Activity") category = "activities";
      }
      list.push(
        <li key={element.category} className="navbar__website__search__result-count">
          {element.count + " " + category.toLowerCase()} found
        </li>
      );
      currentCategory = element.category;
    }
    list.push(
      <li key={element.url} className="navbar__website__search__result-item">
        <a href={element.url}>
          {element.category === "Location" ? (
            <span className="navbar__search_result__item__location">
              <span className="navbar__search__result__item__location__icon" /> {element.label}
            </span>
          ) : (
            <span className="navbar__search_result__item__activity">
              <span>{element.label}</span>
              {element.primary_location && (
                <span className="navbar__search_result__primary_location">
                  <span className="navbar__search__result__item__location__icon" />
                  {element.primary_location}
                </span>
              )}
            </span>
          )}
        </a>
      </li>
    );
  });
  return <ul className="navbar__wholepage__search_container">{list}</ul>;
};

export default WholePageSearchResults;
